import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './App.module.css';
import { LanguageProvider } from './context/LanguageContext';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/pages/Home';
import ServicesPage from './components/pages/ServicesPage';
import ContactPage from './components/pages/ContactPage';
import ProjectsPage from './components/pages/ProjectsPage';
import WebsitePage from './components/pages/WebsitePage';
import SoftwarePage from './components/pages/SoftwarePage';
import AIServicePage from './components/pages/AIServicePage';
import MaintenancePage from './components/pages/MaintenancePage';
import MethodePage from './components/pages/MethodePage';
import AboutPage from './components/pages/AboutPage';

function App() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const mouseRef = useRef({ x: -200, y: -200 });
  const ringPosRef = useRef({ x: -200, y: -200 });
  const rafRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 100 });
  }, []);

  useEffect(() => {
    const onMouseMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
      if (dotRef.current) {
        dotRef.current.style.left = e.clientX + 'px';
        dotRef.current.style.top = e.clientY + 'px';
      }
    };

    const onMouseOver = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select, label')) {
        dotRef.current?.classList.add(styles.cursorHovered);
        ringRef.current?.classList.add(styles.cursorHovered);
      }
    };

    const onMouseOut = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select, label')) {
        dotRef.current?.classList.remove(styles.cursorHovered);
        ringRef.current?.classList.remove(styles.cursorHovered);
      }
    };

    const onMouseLeave = () => {
      dotRef.current?.classList.add(styles.cursorHidden);
      ringRef.current?.classList.add(styles.cursorHidden);
    };
    const onMouseEnter = () => {
      dotRef.current?.classList.remove(styles.cursorHidden);
      ringRef.current?.classList.remove(styles.cursorHidden);
    };

    const animate = () => {
      ringPosRef.current.x += (mouseRef.current.x - ringPosRef.current.x) * 0.13;
      ringPosRef.current.y += (mouseRef.current.y - ringPosRef.current.y) * 0.13;
      if (ringRef.current) {
        ringRef.current.style.left = ringPosRef.current.x + 'px';
        ringRef.current.style.top = ringPosRef.current.y + 'px';
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseout', onMouseOut);
    document.documentElement.addEventListener('mouseleave', onMouseLeave);
    document.documentElement.addEventListener('mouseenter', onMouseEnter);
    rafRef.current = requestAnimationFrame(animate);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseover', onMouseOver);
      document.removeEventListener('mouseout', onMouseOut);
      document.documentElement.removeEventListener('mouseleave', onMouseLeave);
      document.documentElement.removeEventListener('mouseenter', onMouseEnter);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <LanguageProvider>
    <Router>
      <div className={styles.app}>
        <div ref={dotRef} className={styles.cursorDot} />
        <div ref={ringRef} className={styles.cursorRing} />
        <Header />
        <main className={styles.mainContent}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/services/sites-web" element={<WebsitePage />} />
            <Route path="/services/logiciel" element={<SoftwarePage />} />
            <Route path="/services/ia" element={<AIServicePage />} />
            <Route path="/services/maintenance" element={<MaintenancePage />} />
            <Route path="/methode" element={<MethodePage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </LanguageProvider>
  );
}

export default App;
